export default __webpack_public_path__ + "static/logo-0a12ad34e3c6dc82944558c5935d3693.svg";